import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSubmitted(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url('/assets/booking-bg.jpg')" }} aria-hidden />
      <div className="absolute inset-0 bg-[#0B0B0C]/80 backdrop-blur-sm" aria-hidden />
      <div className="relative z-10 w-full max-w-md">
        <Link to="/" className="block text-center mb-10">
          <img src="/assets/brand/phantasm-logo.png" alt="Phantasm Limousine Service Inc." className="mx-auto h-16 w-auto" />
        </Link>
        <div className="backdrop-blur-2xl bg-[#121214]/80 border border-white/10 p-10 shadow-2xl">
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#8E9AA6] mb-3">Account Recovery</div>
          <h1 className="font-serif text-3xl text-white font-semibold tracking-tight mb-8">Forgot password</h1>
          {submitted ? (
            <div data-testid="forgot-success" className="text-sm text-[#E6E6E6] leading-relaxed">
              If an account exists for that email, a reset link has been sent. Please check your inbox.
            </div>
          ) : (
            <form onSubmit={onSubmit} data-testid="forgot-form">
              <label className="block text-xs uppercase tracking-[0.25em] text-[#8E9AA6] mb-3">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email-input"
                autoComplete="email"
                className="w-full bg-transparent border-b border-white/20 px-0 py-3 text-white placeholder-[#8E9AA6] focus:border-white focus:outline-none transition-colors text-base"
                placeholder="you@phantasmlimousineservice.com"
              />
              {error && <div data-testid="forgot-error" className="mt-5 text-xs text-red-400">{error}</div>}
              <button
                type="submit"
                disabled={busy}
                data-testid="forgot-submit-btn"
                className="w-full mt-10 bg-white text-black hover:bg-[#E6E6E6] disabled:opacity-50 px-8 py-4 transition-all duration-300 font-medium text-xs tracking-[0.25em] uppercase"
              >
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
          )}
          <div className="mt-8 text-center text-xs text-[#8E9AA6] tracking-wide">
            <Link to="/login" data-testid="forgot-back-login" className="text-white hover:text-[#E6E6E6] uppercase tracking-[0.2em]">
              ← Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
